<template>
    <Modal v-model="modalVisible" title="导出记录" width="80%" :footer-hide="true">
        <Table :columns="exportColumns" :data="exportList" :loading="exportLoading">
            <template slot-scope="{ row }" slot="exportStatus">
                <Tag :color="row.exportStatus === '2' ? 'success' : row.exportStatus === '3' ? 'error' : 'warning'">
                    {{ row.exportStatus === "2" ? "导出成功" : row.exportStatus === "3" ? "导出失败" : "导出中" }}
                </Tag>
            </template>
            <template slot-scope="{ row }" slot="action">
                <Button v-if="row.exportStatus === '2'" type="primary" size="small" @click="downloadExport(row.exportId)">下载</Button>
            </template>
        </Table>
        <div style="margin-top: 10px; text-align: right">
            <Page
                :total="exportTotal"
                :current="exportPage"
                :page-size="exportPageSize"
                @on-change="handleExportPageChange"
                show-total
                show-elevator
            />
        </div>
    </Modal>
</template>

<script>
export default {
    name: "ExportRecordsModal",
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        orgCode: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            exportList: [],
            exportLoading: false,
            exportPage: 1,
            exportPageSize: 10,
            exportTotal: 0,
            exportColumns: [
                {
                    title: "导出任务名称",
                    key: "exportName",
                    minWidth: 150,
                },
                {
                    title: "导出状态",
                    slot: "exportStatus",
                    minWidth: 100,
                },
                {
                    title: "开始时间",
                    key: "exportStartTime",
                    minWidth: 150,
                    render: (h, params) => {
                        return h(
                            "span",
                            params.row.exportStartTime
                                ? this.$core.formatDate(new Date(params.row.exportStartTime), "yyyy-MM-dd hh:mm:ss")
                                : ""
                        )
                    },
                },
                {
                    title: "结束时间",
                    key: "exportEndTime",
                    minWidth: 150,
                    render: (h, params) => {
                        return h(
                            "span",
                            params.row.exportEndTime ? this.$core.formatDate(new Date(params.row.exportEndTime), "yyyy-MM-dd hh:mm:ss") : ""
                        )
                    },
                },
                {
                    title: "操作",
                    slot: "action",
                    width: 100,
                    align: "center",
                },
            ],
        }
    },
    computed: {
        modalVisible: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit("input", val)
            },
        },
    },
    methods: {
        open() {
            this.$emit("input", true)
            this.refresh()
        },
        refresh() {
            this.exportPage = 1
            this.$nextTick(() => {
                this.getExportList()
            })
        },
        resolveOrgCode() {
            return (
                this.orgCode ||
                window.sessionStorage.getItem("orgCode") ||
                (window.vue && window.vue.loginInfo && window.vue.loginInfo.userinfo && window.vue.loginInfo.userinfo.orgCode) ||
                ""
            )
        },
        getExportList() {
            const orgCode = this.resolveOrgCode()
            this.exportLoading = true
            this.$get("/gateway/syinfopublish/api/pc/platform/taskExport/queryByPage", {
                orgCode: orgCode,
                page: this.exportPage,
                pageSize: this.exportPageSize,
            })
                .then(res => {
                    this.exportLoading = false
                    if (res.code == 200 && res.dataList) {
                        this.exportList = res.dataList || []
                        this.exportTotal = res.maxCount || 0
                    } else {
                        this.exportList = []
                        this.exportTotal = 0
                    }
                })
                .catch(() => {
                    this.exportLoading = false
                    this.exportList = []
                    this.exportTotal = 0
                })
        },
        handleExportPageChange(page) {
            this.exportPage = page
            this.getExportList()
        },
        downloadExport(exportId) {
            this.$get("/gateway/syinfopublish/api/pc/platform/taskExport/downloadExportFile", {
                exportId: exportId,
            })
                .then(res => {
                    if (res.code == 200 && res.data) {
                        window.open(res.data, "_blank")
                    } else {
                        this.$Message.error(res.msg || "下载失败")
                    }
                })
                .catch(() => {
                    this.$Message.error("下载失败")
                })
        },
    },
}
</script>
